import { useEffect } from 'react'
import { useParams } from 'react-router-dom'

import MachinePartsPageHeader from '@/components/pages/MachineParts/List/PageHeader'
import MachinePartsTable from '@/components/pages/MachineParts/List/Table'
import { MachinePart } from '@/types'

import { useMachines } from '../Machine/Machine.hooks'
import { useMachineParts } from './MachinePart.hooks'

const MachineParts = () => {
  const { id } = useParams()

  const {
    getMachinePartsLoading,
    getMachinePartsResponse,
    getMachineParts,
    createWashingHistory,
    getRecentHistory,
    recentHistoryResponse,
    deleteMachinePart,
  } = useMachineParts()

  const { getMachineDetail, getMachineDetailResponse } = useMachines()

  const handleDeleteMachinePart = async (id: MachinePart['id'], machineId: number) => {
    await deleteMachinePart({ id })
    await getMachineParts(machineId)
    await getRecentHistory(machineId)
  }

  const handleCreateWashingHistory = async (id: MachinePart['id'], machineId: number) => {
    await createWashingHistory(id)
    await getMachineParts(machineId)
    await getRecentHistory(machineId)
  }

  useEffect(() => {
    getMachineParts(Number(id))
    getMachineDetail(Number(id))
    getRecentHistory(Number(id))
  }, [getMachineDetail, getMachineParts, getRecentHistory, id])

  return (
    <>
      <MachinePartsPageHeader />
      <MachinePartsTable
        machineId={Number(id)}
        {...{
          dataSource: getMachinePartsResponse,
          dataSourceDetail: getMachineDetailResponse ? [getMachineDetailResponse] : [],
          getMachinePartsLoading,
          dataSourceRecentHistory: recentHistoryResponse || [],
        }}
        onDelete={handleDeleteMachinePart}
        onCreateWashingHistory={handleCreateWashingHistory}
      />
    </>
  )
}

MachineParts.displayName = 'MachineParts'
export default MachineParts
